import { RouteConfig } from 'vue-router';

const routes: Array<RouteConfig> = [
	{
		path: '',
		component: () => import('@/views/luoghi/Luoghi.vue'),
		meta: {
			title: 'luoghi',
			acl: 'section.luoghi'
		}
	}
];

export default routes;